import { useQuery } from '@tanstack/react-query';
import React from 'react'
import { useHistory, useParams } from 'react-router-dom';
import api from 'services/api';
import mockData from "./mock.json";
import { AppEditDataTable } from './AppEditData.Table';
import { IResponse } from './AppEditData.types';
import { IconButton, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export function AppEditDataView() {
  const { workspaceId, templateId, workspaceActivityId } = useParams() as { workspaceId: string, templateId: string, workspaceActivityId: string; };
  const history = useHistory();

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["app_edit_data", workspaceActivityId],
    queryFn: () => api.get<{ data: IResponse }>(`/v2/apps/edit-data/${workspaceActivityId}`),
    select: (data) => data.data.data,
    refetchInterval: 5000,
    // queryFn: () => Promise.resolve({ data: mockData }),
    // select: (data) => data.data,
  });

  // Remove CPFs duplicados, mantendo apenas valores únicos de TAX_PAYER_ID
  const uniquePeople = data?.people ? data.people.filter((person, index, array) => 
    array.findIndex(p => p.TAX_PAYER_ID === person.TAX_PAYER_ID) === index
  ) : [];

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={() => history.push(`/v2/workspaces/${workspaceId}/templates/${templateId}/data-governance`)}
            >
              <ArrowBack color="primary" />
            </IconButton>
            <Typography variant="h6">Editar dados</Typography>
          </div>
          <AppEditDataTable people={uniquePeople} editableFields={data.config}/>
        </>
      )}
    </>
  )
}
